jQuery(function ($) {
    $(document).ready(function () {
        $('.btn-video').click(function () {
            var modalId = $(this).data('bs-target');
            var $modal = $(modalId);

            var $video = $modal.find('video');

            if ($video.length > 0) {
                $video.get(0).play();
            }
        });

        $('.modal').on('click', '.close', function () {
            var $video = $(this).closest('.modal').find('video');

            if ($video.length > 0) {
                $video.get(0).pause();
            }
        });

        $('.btn-video').on('click', function(ev) {
            var modalIdExterno = $(this).data('bs-target');
            var $modalExterno = $(modalIdExterno);
        
            // Inicia a reprodução do vídeo
            var $videoExterno = $modalExterno.find('iframe');
            $videoExterno[0].src += "&autoplay=1";
        
            // Adicione um tratamento de evento quando o modal é fechado
            $modalExterno.on('hidden.bs.modal', function () {
                // Pare a reprodução do vídeo definindo o atributo "src" como uma string vazia
                $videoExterno[0].src = $videoExterno[0].src.split('&autoplay=1')[0];
            });
        });

    });
});